import Image from 'components/Common/Image'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import Pill from 'LuxKit/Pill/Pill'
import useOffer from 'hooks/Offers/useOffer'
import useTourV2PurchasableOptionDetails from 'hooks/TourV2/useTourV2PurchasableOptionDetails'
import useTourV2VariationDetails from 'hooks/TourV2/useTourV2VariationDetails'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { formatMiddleDotSeparator } from 'LuxKit/intl/separators'
import { SEARCH_MENU_LIST_ITEM_CLASS_NAME } from './searchMenuListItemConstants'
import { trackClientEvent } from 'analytics/analytics'
import { findCheapestOfTourV2Offer } from 'lib/tours/tourUtils'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'

interface Props {
  searchPhrase?: string
  searchItem: App.SearchItem
  offerId?: string
  ['data-testid']?: string
  selected?: boolean
}

function SearchMenuTourItem(props: Props) {
  const {
    searchItem,
    offerId,
    selected = false,
  } = props
  const intl = useIntl()
  const id = offerId || searchItem.value.split(':')[1]

  const [offer] = useOffer<App.Tours.TourV2Offer>(id)
  const isLuxPlusMember = useAppSelector(getCanViewLuxPlusBenefits)
  const {
    cheapestPurchasableOption,
    cheapestVariation,
  } = useMemo(() => {
    if (offer) {
      return findCheapestOfTourV2Offer(offer)
    }
    return {}
  }, [offer])

  const {
    placesCount,
    countriesCount,
    durationInDaysCount,
  } = useTourV2VariationDetails(cheapestVariation)

  const {
    valuedAt,
  } = useTourV2PurchasableOptionDetails(cheapestPurchasableOption) || {}

  const title = offer?.name || searchItem?.format?.mainText
  const handleClick = () => {
    trackClientEvent({
      subject: 'click-tour-offer',
      action: 'clicked',
      category: 'logging',
      type: 'operational',
    })
    window.open(`/tour/${id}`, '_blank')
  }

  if (!offer || !cheapestVariation) {
    return null
  }
  return <ClickableListItem
    selected={selected}
    className={SEARCH_MENU_LIST_ITEM_CLASS_NAME}
    startIcon={<Image
      image={cheapestVariation.images[0]}
      height={48}
      width={48}
    />}
    title={title}
    subtitle={<div>
      <p>{durationInDaysCount}{formatMiddleDotSeparator(intl)}{placesCount}{formatMiddleDotSeparator(intl)}{countriesCount}</p>
      {valuedAt && <Pill palette="success">
        {intl.formatMessage(
          {
            id: 'WK5RgZ0NMm6qEuvkGbCB',
            defaultMessage: 'Save up to {discount}%',
          },
          { discount: isLuxPlusMember ? valuedAt.memberSavingsPercentage : valuedAt.savingPercentage },
        )}
      </Pill>}
    </div>}
    onClick={handleClick}
    data-testid={props['data-testid']}
  />
}

export default SearchMenuTourItem
